import styled from 'styled-components';

export interface ValueProp {
  value: number | null | undefined;
}

const PositiveNegativeValue = styled('span')<ValueProp>`
  color: ${({ value, theme }) => {
    if (value === 0 || value === null || value === undefined) {
      return theme.color.whiteRGBA(0.3);
    }
    return value > 0 ? theme.color.good : theme.color.bad;
  }};
`;

export default PositiveNegativeValue;
